import { useState } from "react";

export function SelectGrupo({
  titulo,
  grupos,
  grupoSeleccionado,
  setGrupoSeleccionado,
  placeholder = "Escriba el nombre del grupo",
  filtrarGrupos = () => true,
}) {
  // controla el input y la lista
  const [busqueda, setBusqueda] = useState("");
  // controla la visibilidad de la lista y el input
  const [mostrarOpciones, setMostrarOpciones] = useState(true);

  const handleSelect = (g) => {
    // Actualiza el grupo seleccionado y cierra la lista
    setGrupoSeleccionado(g);
    setBusqueda(g.nombre);
    setMostrarOpciones(false);
  };

  const handleChangeGrupo = () => {
    // “Libera” la selección y vuelve a mostrar opciones
    setGrupoSeleccionado(null);
    setBusqueda("");
    setMostrarOpciones(true);
  };

  const gruposFiltrados = grupos
    .filter((g) => g.nombre.toLowerCase().includes(busqueda.toLowerCase()))
    .filter(filtrarGrupos);

  return (
    <div className="space-y-2">
      <label className="block font-semibold">{titulo}</label>

      {mostrarOpciones ? (
        <>
          <input
            type="text"
            value={busqueda}
            onChange={(e) => setBusqueda(e.target.value)}
            placeholder={placeholder}
            className="border p-2 rounded w-full"
          />
          <ul className="border p-2 rounded bg-white shadow-md max-h-44 overflow-y-auto">
            {gruposFiltrados.length === 0 && (
              <li className="text-gray-500">No se encontraron grupos</li>
            )}
            {gruposFiltrados.map((g) => (
              <li
                key={g.idGrupo}
                className="cursor-pointer p-1 hover:bg-gray-200"
                onClick={() => handleSelect(g)}
              >
                {g.nombre}
              </li>
            ))}
          </ul>
        </>
      ) : (
        <>
          {/* Aquí sólo mostramos un “resumen” de lo que el usuario seleccionó */}
          <div className="border p-2 rounded bg-gray-50 flex justify-between items-center">
            <p className="font-medium">
              {grupoSeleccionado?.nombre || "Ningún grupo seleccionado"}
            </p>
            <button
              type="button"
              onClick={handleChangeGrupo}
              className="text-blue-600 hover:underline"
            >
              Cambiar
            </button>
          </div>
        </>
      )}
    </div>
  );
}
